import {Component, Input} from '@angular/core';
import {InfoPageHeaderComponent} from '../info-page-header/info-page-header.component';
import {CommonModule} from '@angular/common';
import {SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-info-page',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.scss'],
  imports: [
    InfoPageHeaderComponent,
    CommonModule
  ]
})
export class InfoPageComponent {
  @Input() title!: string;
  @Input() subtitle?: string;
  @Input() prefix?: string;

  @Input() videoSrc?: SafeResourceUrl | null;
  @Input() videoPoster?: string | null;

  @Input() imageSrc?: string | null;
  @Input() imageAlt?: string | null;

  constructor() {
  }
}

